export const environment = {
  production: false,
  appName : 'myha-e-commerce-admin-portal',
  version : '1.0.0',
  API_ENDPOINT : 'https://dev-api.myhealthadvisor.com.my/ecommerce',
  COOKIE_PATH : '/'
};
